import React from "react";
import ReactMarkdown from "react-markdown";
import Brand from "../../components/Brand";
import Button from "../../components/Button";
// import CodeSample from "../../components/CodeSample";
import about from "../../markdown/About.md";
import "./Splash.css";

const Splash = () => (
  <div>
    <div className="splash">
      <div className="splashMain">
        <Brand />
        <div className="info">
          {/*
          <CodeSample>
            gndrv clone my-part<br />
            cd my-part<br />
            gndrv install
          </CodeSample>
          */}
          <div className="buttonContainer">
            <Button linkPath="/login">Login</Button>
            <Button linkPath="/user/new">Sign up</Button>
          </div>
        </div>
      </div>
    </div>
    <div className="splashAbout">
      <ReactMarkdown source={about} className="text" />
    </div>
  </div>
);

export default Splash;



// WEBPACK FOOTER //
// ./src/pages/Splash/Splash.js